import React from "react"
import { graphql } from "gatsby"
import SEO from "../components/SEO"
import Img from "gatsby-image"
// import Image from "gatsby-image"
// import Layout from "../components/layout"
import { IoIosArrowDropright } from "react-icons/io"
import Welcome from "../components/indexPage/Welcome"
import ChiefAndCouncil from "../components/indexPage/ChiefAndCouncil"
import OurPrograms from "../components/indexPage/OurPrograms"
import LatestNews from "../components/indexPage/LatestNews"
import Hero from "../components/Hero"
import Layout from "../components/layout"

const IndexPage = ({ data }) => {
  const { homePageData, blogPosts, indexBG, logo } = data
  debugger
  return (
    <Layout>
      <div
        Tag="section"
        fluid={data.indexBG.childImageSharp.fluid}
        className="index__bgImage-container z-0 relative"
      >
        {/* Image courtesy of Mahir Uysal on Unsplash https://unsplash.com/@mahiruysal */}
        <SEO title="Home" />
        <Hero fluid={indexBG.childImageSharp.fluid} className="py-32 md:py-20">
          <div className="grid justify-items-center mt-20">
            <h1 className="leading-tight text-white text-center text-5xl md:text-6xl uppercase">
              Wawakapewin First Nation
            </h1>
            <div className="md:w-500px hidden md:block">
              <Img fluid={logo.childImageSharp.fluid} className="" />
            </div>
          </div>
        </Hero>
        {/* Subtitle */}
        {/* Contain all sections of Index page to maintain same spacing at sides */}
        <div className="grid gap-y-20  px-2 md:px-10 lg:px-10 pt-20 pb-10  relative bg-gradient-to-b  from-white to-blue-med">
          <div className="relative grid justify-center p-8 bg-secondary -mt-48 mb-12 rounded max-w-4xl justify-self-center shadow-lg">
            <p className="text-white text-4xl text-center font-bold font-heading">
              {homePageData.welcomeStatement}
            </p>

            {/* border color works with tailwind colors */}
            {/* reqiures parent to be position:relative */}
            {/* <AccentBoxWhite className="-bottom-3 -right-3" borderColor="white" /> */}
          </div>
          <Welcome
            subTitle={homePageData.welcomeStatement}
            text={homePageData.greetingsBlurb}
          />
          <LatestNews blogPosts={blogPosts} />

          {/* Chief and Council */}
          <ChiefAndCouncil
            textIcon={<IoIosArrowDropright className="inline" />}
            text={homePageData.chiefAndCouncilBlurb}
            fluidImage={
              homePageData.chiefAndCouncilImage
                ? homePageData.chiefAndCouncilImage.asset.fluid
                : null
            }
          />
          {/* Our programs */}
          <OurPrograms
            textIcon={<IoIosArrowDropright className="inline" />}
            text={homePageData.programsBlurb}
            fluidImage={
              homePageData.programsImage
                ? homePageData.programsImage.asset.fluid
                : null
            }
          />
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    indexBG: file(relativePath: { eq: "aerial1.jpg" }) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 2000) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    logo: file(relativePath: { eq: "2013_logo.png" }) {
      id
      childImageSharp {
        fluid(quality: 100, maxWidth: 500) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    homePageData: sanityHomePage {
      title
      programsBlurb
      welcomeStatement
      greetingsBlurb
      ...ChiefAndCouncil
      programsImage {
        altText
        asset {
          id
          fluid(maxWidth: 500) {
            ...GatsbySanityImageFluid
          }
        }
      }
    }
    blogPosts: allSanityBlogPost {
      edges {
        node {
          ...LatestNews
        }
      }
    }
  }
`

export default IndexPage
